
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.174 20.296"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Сгруппировать 28831"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28830"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28829","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Контур 34846","d":"M17.438 4.079l-9.531 5.87a1.426 1.426 0 00-.621 1.6l1.031 3.621a.7.7 0 00.679.514h.053a.7.7 0 00.65-.612l.268-1.985a1.173 1.173 0 01.362-.7l7.865-7.311a.628.628 0 00-.756-.994zm-7.737 7.629a2.1 2.1 0 00-.648 1.252l-.13.963-.748-2.628a.5.5 0 01.217-.56l6.982-4.3z"}}),_c('path',{attrs:{"data-name":"Контур 34847","d":"M22.8.253a1.065 1.065 0 00-1.073-.181L.682 8.189a1.066 1.066 0 00.011 1.994l4.915 1.834 1.917 6.166a1.065 1.065 0 001.691.509l2.858-2.33a.391.391 0 01.477-.013l5.155 3.742a1.066 1.066 0 001.67-.645l3.776-18.164A1.066 1.066 0 0022.8.253zm-.549.842l-3.78 18.164a.143.143 0 01-.224.086l-5.154-3.74a1.316 1.316 0 00-1.6.045l-2.858 2.33a.142.142 0 01-.226-.068l-1.987-6.386a.462.462 0 00-.279-.3L1.016 9.318a.143.143 0 010-.268L22.058.933a.143.143 0 01.191.162z"}})])])]),_c('g',{attrs:{"data-name":"Сгруппировать 28833"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28832"}},[_c('path',{attrs:{"data-name":"Контур 34848","d":"M19.353 9.973a.462.462 0 00-.549.353l-.07.323a.462.462 0 10.9.2l.07-.323a.462.462 0 00-.351-.553z","fill":"#fff"}})])]),_c('g',{attrs:{"data-name":"Сгруппировать 28835"}},[_c('g',{attrs:{"data-name":"Сгруппировать 28834"}},[_c('path',{attrs:{"data-name":"Контур 34849","d":"M18.886 12.101a.462.462 0 00-.549.353l-1.062 4.891a.462.462 0 10.9.2l1.062-4.891a.462.462 0 00-.351-.553z","fill":"#fff"}})])])])
          )
        }
      }
    